<div mat-dialog-title class="dialog-info" closeOnEscape>
    <label class="dialogTitle">
        {{'MATERIAL_CHANGER' | translate}}
    </label>
    <button type="button" class="btn-close btn-close-white shadow-none crossButtonPosition" [mat-dialog-close]></button>
</div>

<mat-dialog-content class="contentPadding">
    <div class="table-container">
        <table mat-table [dataSource]="dataSource" matSort (matSortChange)="onSortChange($event)" [trackBy]="trackByMaterial"
            class="full-width table table-bordered">
            <ng-container matColumnDef="ssn">
                <th mat-header-cell *matHeaderCellDef mat-sort-header > {{ 'MATERIAL' | translate }} </th>
                <td mat-cell *matCellDef="let element" class="table-data">
                    {{element.referenceNumber}} </td>
            </ng-container>
            
            <ng-container matColumnDef="changeType">
                <th mat-header-cell *matHeaderCellDef mat-sort-header > {{ 'CHANGE' | translate}} </th>
                <td mat-cell *matCellDef="let element" class="table-data">
                    {{element.changeType}} </td>
            </ng-container>
            
            <ng-container matColumnDef="isPBOMarked">
                <th mat-header-cell *matHeaderCellDef mat-sort-header > {{ 'PROVIDED_BY_OTHERS' | translate}} </th>
                <td mat-cell *matCellDef="let element" class="table-data">
                    {{element.isPBOMarked}} </td>
            </ng-container>
            
            <ng-container matColumnDef="oldCost">
                <th mat-header-cell *matHeaderCellDef mat-sort-header > {{ 'CURRENT' | translate}} ($) </th>
                <td mat-cell *matCellDef="let element" class="table-data align-right">
                    {{element.oldCost | currency:'$':true}} </td>
            </ng-container>
            
            <ng-container matColumnDef="newCost">
                <th mat-header-cell *matHeaderCellDef mat-sort-header > {{ 'NEW' | translate}} ($) </th>
                <td mat-cell *matCellDef="let element" class="table-data align-right">
                    {{element.newCost | currency:'$':true}} </td>
            </ng-container>
            
            <ng-container matColumnDef="currentList">
                <th mat-header-cell *matHeaderCellDef mat-sort-header > {{ 'CURRENT_LIST' | translate}} ($) </th>
                <td mat-cell *matCellDef="let element" class="table-data align-right">
                    {{element.currentList | currency:'$':true}} </td>
            </ng-container>
            
            <ng-container matColumnDef="newList">
                <th mat-header-cell *matHeaderCellDef mat-sort-header > {{ 'NEW_LIST' | translate}} ($) </th>
                <td mat-cell *matCellDef="let element" class="table-data align-right">
                    {{element.newList | currency:'$':true}} </td>
            </ng-container>
            
            <ng-container matColumnDef="costPlus">
                <th mat-header-cell *matHeaderCellDef mat-sort-header > {{ 'COST_PLUS' | translate}} </th>
                <td mat-cell *matCellDef="let element" class="table-data">
                    {{element.costPlus}} </td>
            </ng-container>
            
            <ng-container matColumnDef="anyLaborChange">
                <th mat-header-cell *matHeaderCellDef mat-sort-header > {{ 'ANY_LABOR_CHANGE' | translate}} </th>
                <td mat-cell *matCellDef="let element" class="table-data">
                    {{isAnyLaborChange(element)}} </td>
            </ng-container>
            
            <ng-container matColumnDef="currentTaskCategoryNo">
                <th mat-header-cell *matHeaderCellDef mat-sort-header > {{ 'CURRENT_TASK_CATEGORY' | translate}} </th>
                <td mat-cell *matCellDef="let element" class="table-data">
                    {{element.currentTaskCategory}} </td>
            </ng-container>
            
            <ng-container matColumnDef="newTaskCategory">
                <th mat-header-cell *matHeaderCellDef mat-sort-header > {{ 'NEW_TASK_CATEGORY' | translate}} </th>
                <td mat-cell *matCellDef="let element" class="table-data">
                    {{element.newTaskCategory}} </td>
            </ng-container>
            
            <ng-container matColumnDef="currentVendorNumber">
                <th mat-header-cell *matHeaderCellDef mat-sort-header > {{ 'CURRENT_VENDOR_NUMBER' | translate}} </th>
                <td mat-cell *matCellDef="let element" class="table-data">
                    {{element.currentVendorNumber}} </td>
            </ng-container>
            
            <ng-container matColumnDef="newVendorNumber">
                <th mat-header-cell *matHeaderCellDef mat-sort-header > {{ 'NEW_VENDOR_NUMBER' | translate}} </th>
                <td mat-cell *matCellDef="let element" class="table-data">
                    {{element.newVendorNumber}} </td>
            </ng-container>
            
            <ng-container matColumnDef="currentModelNumber">
                <th mat-header-cell *matHeaderCellDef mat-sort-header > {{ 'CURRENT_MODEL_NUMBER' | translate}} </th>
                <td mat-cell *matCellDef="let element" class="table-data">
                    {{element.currentModelNumber}} </td>
            </ng-container>
            
            <ng-container matColumnDef="newModelNumber">
                <th mat-header-cell *matHeaderCellDef mat-sort-header > {{ 'NEW_MODEL_NUMBER' | translate}} </th>
                <td mat-cell *matCellDef="let element" class="table-data">
                    {{element.newModelNumber}} </td>
            </ng-container>
            
            <ng-container matColumnDef="type">
                <th mat-header-cell *matHeaderCellDef mat-sort-header > {{ 'TYPE' | translate}} </th>
                <td mat-cell *matCellDef="let element" class="table-data">
                    {{getMaterialCategoryName(element.type)}} </td>
            </ng-container>
            
            <ng-container matColumnDef="currentIOType">
                <th mat-header-cell *matHeaderCellDef mat-sort-header > {{ 'CURRENT_FIXED_IO' | translate}} </th>
                <td mat-cell *matCellDef="let element" class="table-data">
                    {{element.currentIOType}} </td>
            </ng-container>
            
            <ng-container matColumnDef="newIOType">
                <th mat-header-cell *matHeaderCellDef mat-sort-header > {{ 'NEW_FIXED_IO' | translate}} </th>
                <td mat-cell *matCellDef="let element" class="table-data">
                    {{element.newIOType}} </td>
            </ng-container>
    
            <!-- Header row -->
            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true" class="row-height row-header" ></tr>
            <!-- Data rows -->
            <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="row-height"
                [class.selected-row]="selectedRow === row" (click)="onRowClick(row)">
            </tr>
    
            <!-- Row shown when there is no matching data -->
            <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell no-data text-center" [attr.colspan]="displayedColumns.length">{{
                    'COMMON_LABELS.NO_DATA_FOUND' | translate }}</td>
            </tr>
        </table>
    </div>
    @if (totalCount > 0) {
        <div class="col-sm-12 row mat-paginator-sticky paginationDiv">
            <div class="col-sm-3 pt-3">
                <div class="goToTextBox">
                    <input type="number" min="1" [max]="totalPages" class="form-control form-control-sm"
                        [(ngModel)]="gotoPageNumber" [ngModelOptions]="{standalone: true}" (keyup.enter)="gotoPage()"
                        placeholder="{{'GOTO' | translate}}">
                </div>
                <div>
                    <p class="currentTotalLable">
                        {{'COMMON_LABELS.PAGES' | translate}}: {{currentPageNumber}} {{'COMMON_LABELS.OF' | translate}} {{totalPages}}
                    </p>
                </div>
            </div>
            <div class="col-sm-9 currentTotalLable">
                <mat-paginator
                    [length]="totalCount"
                    [pageSize]="pageSize"
                    [pageIndex]="currentPageNumber - 1"
                    [showFirstLastButtons]="true"
                    [hidePageSize]="true"
                    (page)="onPageChange($event)">
                </mat-paginator>
            </div>
        </div>
    }
</mat-dialog-content>

<mat-dialog-actions align="end" class="actionsPadding">
    <div class="icon-container">
        <button mat-icon-button (click)="copyToClipboard()" [matTooltip]="'COPY_TO_CLIPBOARD' | translate"> 
            <mat-icon>content_copy</mat-icon>
        </button>
        <button mat-icon-button (click)="exportToExcel()" [matTooltip]="'EXPORT_TO_EXCEL' | translate">
            <mat-icon>table_view</mat-icon>
        </button>
    </div>
    <button class="openCloseBtn" mat-raised-button color="warn" mat-dialog-close>{{'CLOSE' | translate}}</button>
</mat-dialog-actions>